import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-the-form-step__wrap" }
const _hoisted_2 = { class: "p-the-form-step__item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconStepOver = _resolveComponent("IconStepOver")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconStepCurrent = _resolveComponent("IconStepCurrent")!
  const _component_IconStepYet = _resolveComponent("IconStepYet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      class: _normalizeClass(["p-the-form-step", { 'p-the-form-step--admin': _ctx.isAdmin }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, key) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["p-the-form-step__item", {
          'p-the-form-step__over': option.step < _ctx.step,
          'p-the-form-step__current': option.step === _ctx.step,
          'p-the-form-step__yet': option.step > _ctx.step
        }]),
          key: key
        }, [
          _createElementVNode("i", {
            class: "p-the-form-step__line",
            style: _normalizeStyle({ backgroundColor: option.step <= _ctx.step ? _ctx.colorCode : '' })
          }, null, 4),
          _createElementVNode("span", _hoisted_2, _toDisplayString(option.label), 1),
          (option.step < _ctx.step)
            ? (_openBlock(), _createBlock(_component_IconBase, {
                key: 0,
                class: "p-the-form-step__item__icon",
                style: _normalizeStyle({ color: _ctx.colorCode }),
                "view-box": "0 0 24 24",
                width: "24",
                height: "24"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconStepOver)
                ]),
                _: 1
              }, 8, ["style"]))
            : (option.step === _ctx.step)
              ? (_openBlock(), _createBlock(_component_IconBase, {
                  key: 1,
                  class: "p-the-form-step__item__icon",
                  style: _normalizeStyle({ color: _ctx.colorCode }),
                  "view-box": "0 0 24 24",
                  width: "24",
                  height: "24"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconStepCurrent)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (option.step > _ctx.step)
                ? (_openBlock(), _createBlock(_component_IconBase, {
                    key: 2,
                    class: "p-the-form-step__item__icon",
                    "view-box": "0 0 24 24",
                    width: "24",
                    height: "24"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconStepYet)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ], 2)
  ]))
}